import { createContext } from 'react';
import type { Tenant } from '../../types';

export default createContext<Tenant| null>(null);
